<div class="bg-th-yellow mt-0 mb-1 container-fluid">

    <div class="d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2">

            {{ bPersonnel ? 'جستجوی پرسنل' : 'جستجوی دانش آموزان' }}

        </span>

    </div>

</div>

<form #form="ngForm" (ngSubmit)="searchStudent(form)" class="rtl w-100 row gx-2 gy-3 p-2">

    <div class="col-12 col-md-3">

        <input ngModel name="strFullName" type="text" class="form-control" placeholder="نام و نام خانوادگی ">

    </div>

    <!-- پایه تحصیلی -->

    <div class="col-12 col-md-2" *ngIf="!bPersonnel">

        <select required class="form-control" [ngModel]="-1" name="tiGrade">

            <option [value]="-1"> پایه تحصیلی </option>

            <option *ngFor="let item of list_Grade" [value]="item.tiGrade"> {{item.strGrade}} </option>

        </select>

    </div>

    <!-- کلاس -->

    <div class="col-12 col-md-2" *ngIf="!bPersonnel">

        <select required class="form-control" [ngModel]="-1" name="tiClassNo">

            <option [value]="-1"> کلاس </option>

            <option *ngFor="let item of list_Class" [value]="item.tiClassNo"> {{item.strTitel}} </option>

        </select>

    </div>

    <div class="col-12 col-md-2">

        <input ngModel name="strMobile" maxlength="11" oninput="this.value=this.value.replace(/[^0-9]/g,'');if(this.value != ''){dir='ltr'};
            
            if(this.value == ''){dir='rtl'};" class="form-control" placeholder="شماره موبایل ">

    </div>

    <div class="col-12 col-md-2">

        <input ngModel name="strNationalCode" maxlength="10" oninput="this.value=this.value.replace(/[^0-9]/g,'');if(this.value != ''){dir='ltr'};
        
        if(this.value == ''){dir='rtl'};" class="form-control"
            [placeholder]="bPersonnel ? 'کد ملی/ پرسنلی' : 'کد ملی' ">

    </div>

    <div class="col-12 col-md-2">

        <select [ngModel]="-1" name="tiSex" class="form-control">

            <option value="-1">جنسیت</option>

            <option value="1">آقا</option>

            <option value="2">خانم</option>

        </select>

    </div>

    <div class="form col-12 col-md-3 position-relative">

        <custom-filter *ngIf="list_Schools.length > 0" [strValue]="''" [strComment]="'strComment'"
            [stylesArray]="['padding-top: 10px']"
            [str_Placeholder]="bPersonnel ? 'نام حوزه خدمت را جستجو کنید' : 'نام مدرسه را جستجو کنید'"
            [lst_Main]="list_Schools" [lst_SearchKey]="['strComment']" [isDisabled]="false"
            (hideOptions)="iMobileDomain=$event.iMobileDomain">

        </custom-filter>

    </div>

    <div class="col-12 col-md-auto d-flex align-items-center">

        <div class="form-check form-check-inline">

            <input class="form-check-input" type="radio" ngModel name="tiAvatarStatus" id="inlineRadio1" value="-1"
                checked>

            <label class="form-check-label pointer" for="inlineRadio1"> همه </label>

        </div>

        <div class="form-check form-check-inline">

            <input class="form-check-input" type="radio" ngModel name="tiAvatarStatus" id="inlineRadio2" value="0">

            <label class="form-check-label pointer" for="inlineRadio2"> بدون عکس </label>

        </div>

        <div class="form-check form-check-inline">

            <input class="form-check-input" type="radio" ngModel name="tiAvatarStatus" id="inlineRadio3" value="1">

            <label class="form-check-label pointer" for="inlineRadio3"> عکس دار </label>

        </div>

    </div>

    <!-- جستجو -->

    <div class="col-12 col-md-auto text-end">

        <button class="btn btn-primary"> &nbsp; جستجو &nbsp; </button>

    </div>

    <!-- افزودن پرسنل -->

    <ng-container *ngIf="bPersonnel">

        <div class="col-12 col-md-auto text-end">

            <button type="button" class="btn btn-success" (click)="newPersonnel()">

                &nbsp; افزودن &nbsp;

                <i class="fa fa-plus mx-1" aria-hidden="true"></i>

            </button>

        </div>

    </ng-container>

</form>

<main class="rtl px-2">

    <span *ngIf="list_Students.length > 0"> تعداد

        <span class="text-danger fw-bold"> {{ list_Students.length | faNum }} </span>

        مورد یافت شد

    </span>

    <div class="row gx-2 align-items-center mt-1 border border-2 p-2">

        <div [ngClass]="list_Students.length == 0 ? 'col-md-12' : 'col-md-6' ">

            <input type="search" #search (input)="searchBy(search.value)" class="form-control" placeholder="جستجو کنید">

        </div>

        <div *ngIf="list_Students.length > 0" class="col-12 col-md-6 text-end">

            <button class="col-12 col-md-auto w-md-auto btn btn-warning" (click)="showAll()">

                <span> نمایش همه روی نقشه </span>

                <i class="fa fa-map-o mx-2" aria-hidden="true"></i>

            </button>

            <button class="col-12 col-md-auto w-md-auto btn my-2 my-md-0 mx-0 mx-md-1 btn-danger"
                (click)="message_Modal()">

                <span> ارسال پیام </span>

                <i class="fa fa-envelope mx-2" aria-hidden="true"></i>

            </button>

            <button class="col-12 col-md-auto w-md-auto btn btn-success" (click)="exportExcel()">

                <span> خروجی اکسل </span>

                <i class="fa fa-file-excel-o mx-2" aria-hidden="true"></i>

            </button>

        </div>

        <div class="section border border-2 mt-2" style="max-height:70vh;overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <!-- پرسنل -->

                <ng-container *ngIf="bPersonnel;else Student;">

                    <thead>

                        <tr class="text-center">

                            <th>#</th>

                            <th>عملیات</th>

                            <th> نام </th>

                            <th> نام خانوادگی </th>

                            <th> موبایل </th>

                            <th> شماره پرسنلی </th>

                            <th> حوزه خدمت </th>

                            <th> جایگاه سازمانی </th>

                        </tr>

                    </thead>

                </ng-container>

                <!-- دانش آموزان -->

                <ng-template #Student>

                    <thead>

                        <tr class="text-center">

                            <th class="col-1"> عملیات </th>

                            <th (click)="selectAllCheckBox()" class="pointer"> انتخاب </th>

                            <th class="col-1"> نام </th>

                            <th (click)="sortBy(0)" class="pointer">

                                نام خانوادگی

                                <i class="fa fa-sort ms-1" aria-hidden="true"></i>

                            </th>

                            <th> پایه </th>

                            <th> کلاس </th>

                            <th>کد ملی</th>

                            <th> موبایل </th>

                            <th> دسترسی محدوده </th>

                            <th> شهر </th>

                            <th> جنسیت </th>

                            <th (click)="sortBy(1)" class="pointer">

                                {{ bPersonnel ? 'حوزه خدمت' : 'مدرسه' }}

                                <i class="fa fa-sort ms-1" aria-hidden="true"></i>

                            </th>

                            <th> ناحیه </th>

                            <th> مقطع </th>

                            <th> جنسیت </th>

                            <th> نوع مدرسه </th>

                        </tr>

                    </thead>

                </ng-template>

                <tbody>

                    <!-- پرسنل -->

                    <ng-container *ngIf="bPersonnel;else StudentData;">

                        <tr class="col-12 text-center" *ngFor="let item of list_Students; let i = index">

                            <td> {{ i + 1 | faNum }} </td>

                            <td class="col-2">

                                <!-- موقعیت -->

                                <i class="fa fa-map-marker fa-lg px-3 btn btn-primary" title="موقعیت"
                                    (click)="showOnMap(item)">

                                </i>

                                <!-- مشخصات -->

                                <i class="fa fa-info-circle fa-lg my-2 mx-2 btn btn-dark" title="مشخصات"
                                    (click)="showDetail(item)">

                                </i>

                                <!-- تاریخچه اقدامات -->

                                <i class="fa fa-history fa-lg my-2 btn btn-warning" (click)="showHistory(item)"
                                    title="تاریخچه اقدامات">
                                </i>

                                <!-- ویرایش پرسنل -->

                                <i class="fa fa-pencil-square-o fa-lg my-2 ms-2 btn btn-secondary" title="ویرایش پرسنل"
                                    (click)="editPersonnel(item,i)">

                                </i>

                                <!-- حذف -->

                                <i class="fa fa-trash fa-lg my-2 btn btn-danger" (click)="removePersonnel(item)"
                                    title="حذف">
                                </i>

                            </td>

                            <td> {{ item.strName | faNum }} </td>

                            <td> {{ item.strFamily | faNum }} </td>

                            <td> {{ item.strMobile | faNum }} </td>

                            <td> {{ item?.strNationalCode | faNum }} </td>

                            <td> {{ item.strMobileDomain_strComment | faNum }} </td>

                            <td> {{ item.strUserManager_Chart_strComment | faNum }} </td>

                        </tr>

                    </ng-container>

                    <!-- دانش آموزان -->

                    <ng-template #StudentData>

                        <tr class="col-12 text-center" *ngFor="let item of list_Students">

                            <td class="col-1 pointer" (click)="clickedItem=item">

                                <i class="fa fa-info-circle fa-lg" aria-hidden="true" id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown" aria-expanded="false"></i>

                                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1"
                                    style="z-index: 10001!important;">

                                    <!-- موقعیت -->

                                    <li class="dropdown-li" (click)="showOnMap(item)">

                                        <i class="fa fa-map-marker fa-lg" title="موقعیت" aria-hidden="true"></i>

                                        <span> موقعیت </span>

                                    </li>

                                    <!-- جزئیات -->

                                    <li class="dropdown-li" (click)="showDetail(item)">

                                        <i class="fa fa-info-circle fa-lg" title="جزئیات" aria-hidden="true"></i>

                                        <span> جزئیات </span>

                                    </li>

                                    <!-- تاریخچه اقدامات -->

                                    <li *ngIf="bAction_Std" class="dropdown-li" (click)="showHistory(item)">

                                        <i class="fa fa-history fa-lg" title="تاریخچه اقدامات" aria-hidden="true"></i>

                                        <span> تاریخچه اقدامات </span>

                                    </li>

                                    <!-- ویرایش -->

                                    <li *ngIf="bEdit_Std" class="dropdown-li" (click)="editStd(item)">

                                        <i class="fa fa-pencil-square-o fa-lg"
                                            [title]="bPersonnel ? 'ویرایش پرسنل' : 'ویرایش دانش آموز' "
                                            aria-hidden="true"></i>

                                        <span> {{ bPersonnel ? 'ویرایش پرسنل' : 'ویرایش دانش آموز' }} </span>

                                    </li>

                                    <!-- واریزی ها -->

                                    <li *ngIf="bFinancial_Std" class="dropdown-li" (click)="showFinancial(item)">

                                        <i class="fa fa-usd fa-lg" title="واریزی ها" aria-hidden="true"></i>

                                        <span> واریزی ها </span>

                                    </li>

                                    <!-- حضور غیاب -->

                                    <li *ngIf="bAbsence" class="dropdown-li" (click)="checkAbsence(item)">

                                        <i class="fa fa-hand-paper-o fa-lg" title="حضور غیاب" aria-hidden="true"></i>

                                        <span> حضور غیاب </span>

                                    </li>

                                    <!-- گزارش های روزانه  -->

                                    <li *ngIf="accessibility('bSchoolService_DailyReports')" class="dropdown-li" (click)="viewItem(item)">

                                        <i class="fa fa-file fa-lg" title="گزارش های روزانه " aria-hidden="true"></i>

                                        <span> گزارش های روزانه </span>

                                    </li>

                                    <!-- شارژ اعتبار -->

                                    <li class="dropdown-li" *ngIf="accessibility('bSchool_Student_Credit')" (click)="openCredit(item)">

                                        <i class="fa fa-credit-card-alt fa-lg" title="شارژ اعتبار " aria-hidden="true"></i>

                                        <span> شارژ اعتبار </span>

                                    </li>

                                </ul>

                            </td>

                            <td><input type="checkbox" (change)="setCheckBox($event.target.checked,item)" [checked]="isSelected(item.iPassenger)"></td>

                            <td class="col-1">{{item.strName}}</td>

                            <td class="col-1">{{item.strFamily}}</td>

                            <td>{{ item.strGrade }}</td>

                            <td>{{ item.strClassNo_strTitle }}</td>

                            <td>{{ item.strNationalCode | faNum }}</td>

                            <td>{{item.strMobile | faNum}}</td>

                            <td class="col-1">{{ item.bStudentsDeActive ? 'دارد' : 'ندارد' }}</td>

                            <td class="col-1">{{ item.strCityName }}</td>

                            <td class="col-1">{{ item.strSex_strSexComment }}</td>

                            <td>{{item.strMobileDomain_strComment}}</td>

                            <td>{{ item.strEducationDistrict_strComment }}</td>

                            <td>{{ item.strEducationLevel_strComment }}</td>

                            <td>{{ item.strGender }}</td>

                            <td>{{ item.strSchoolType_strComment }}</td>

                        </tr>

                    </ng-template>


                </tbody>

            </table>

        </div>

    </div>

</main>

<!-- عملیات -->

<div class="modal fade" id="operation_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> عملیات </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div class="row gx-2 gy-2">

                    <!-- موقعیت -->

                    <div class="col-md-3 col-12">

                        <button class="w-100 btn btn-primary" data-bs-dismiss="modal" (click)="showOnMap(clickedItem)">

                            موقعیت

                        </button>

                    </div>

                    <!-- جزئیات -->

                    <div class="col-md-3 col-12">

                        <button class="w-100 btn btn-outline-dark" data-bs-dismiss="modal"
                            (click)="showDetail(clickedItem)">

                            جزئیات

                        </button>

                    </div>

                    <!-- تاریخچه اقدامات -->

                    <div *ngIf="bAction_Std" class="col-md-3 col-12">

                        <button class="w-100 btn btn-danger" data-bs-dismiss="modal" (click)="showHistory(clickedItem)">

                            تاریخچه اقدامات

                        </button>

                    </div>

                    <!-- واریزی ها -->

                    <div *ngIf="bFinancial_Std" class="col-md-3 col-12">

                        <button class="w-100 btn btn-outline-success" data-bs-dismiss="modal"
                            (click)="showFinancial(clickedItem)">

                            واریزی ها

                        </button>

                    </div>

                    <!-- حضور غیاب -->

                    <div *ngIf="bAbsence" class="col-md-3 col-12">

                        <button class="w-100 btn btn-success" data-bs-dismiss="modal"
                            (click)="checkAbsence(clickedItem)">

                            حضور غیاب

                        </button>

                    </div>

                    <!-- گزارش های روزانه -->

                    <div *ngIf="accessibility('bSchoolService_DailyReports')" class="col-md-3 col-12">

                        <button class="w-100 btn btn-secondary" data-bs-dismiss="modal" (click)="viewItem(clickedItem)">

                            گزارش های روزانه

                        </button>

                    </div>

                    <!-- 'ویرایش پرسنل' : 'ویرایش دانش آموز'-->

                    <div *ngIf="bEdit_Std" class="col-md-3 col-12">

                        <button class="w-100 btn btn-warning" data-bs-dismiss="modal" (click)="editStd(clickedItem)">

                            {{ bPersonnel ? 'ویرایش پرسنل' : 'ویرایش دانش آموز' }}

                        </button>

                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<div class="modal fade" id="detailModal" style="z-index: 100000000000000;" tabindex="-1" data-backdrop="false"
    data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title"> {{ bPersonnel ? 'جزئیات پرسنل' : 'جزئیات دانش آموز' }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div dir="rtl" class="row justify-content-center align-items-center p-2 gx-2 gy-2">

                <div class="col-12 text-center col-md-3">

                    <img class="rounded-circle" width="150" height="150"
                        src="{{studentData?.strAvatar != '' ? 'data:image/jpeg;base64,' +  studentData?.strAvatar : '../../../../assets/Img/111-1114718_transparent-sleep-icon-png-person-icon-circle-png.jpg' }}"
                        alt="">

                </div>

                <div class="col-12 col-md-9 row gx-2 gy-2">

                    <div class="col-12 col-md-3">

                        <label>نام</label>

                        <input type="text" [ngModel]="studentData?.strName" class="form-control">

                    </div>

                    <div class="col-12 col-md-3">

                        <label>نام خانوادگی</label>

                        <input type="text" [ngModel]="studentData?.strFamily" class="form-control">

                    </div>

                    <div class="col-12 col-md-3">

                        <label>پایه</label>

                        <input type="text" [ngModel]="studentData?.strGrade" class="form-control">

                    </div>

                    <div class="col-12 col-md-3">

                        <label>کلاس</label>

                        <input type="text" [ngModel]="studentData?.strClassNo_strTitle" class="form-control">

                    </div>

                    <div class="col-12 col-md-3">

                        <label>جنسیت</label>

                        <input type="text" [ngModel]="studentData?.strSex_strSexComment" class="form-control">

                    </div>

                    <div class="col-12 col-md-3">

                        <label>شماره موبایل</label>

                        <input dir="ltr" type="text" [ngModel]="( studentData?.strMobile | faNum )"
                            class="form-control">

                    </div>

                    <div class="col-12 col-md-3">

                        <label> {{ bPersonnel ? 'کد ملی / پرسنلی' : 'کد ملی' }} </label>

                        <input dir="ltr" type="text" [ngModel]="( studentData?.strNationalCode | faNum)"
                            class="form-control">

                    </div>


                    <div class="col-12 col-md-6">

                        <label> {{ bPersonnel ? 'حوزه خدمت' : 'مدرسه' }} </label>

                        <input type="text" [ngModel]="studentData?.strMobileDomain_strComment" class="form-control">

                    </div>

                    <div class="col-12 col-md-6">

                        <label> نام راننده </label>

                        <input type="text" [ngModel]="studentData?.strFullName" class="form-control text-danger">

                    </div>

                    <div class="col-12">

                        <label> آدرس </label>

                        <input type="text" [ngModel]="studentData?.strAddress" class="form-control">

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>

<div class="modal fade" id="stdLocation" tabindex="-1" aria-labelledby="" aria-hidden="true" data-backdrop="false"
    data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-xl">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h3 class="modal-title"> موقعیت</h3>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div id="map2" class="position-sticky w-100 " style="height: 500px;">

                <div class="position-absolute" id="map_tooltip" data-bs-html="true"></div>

            </div>

        </div>

    </div>

</div>

<div class="modal fade" id="showAll" tabindex="-1" aria-labelledby="" aria-hidden="true" data-backdrop="false"
    data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-xl">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h3 class="modal-title"> نمایش همه </h3>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class=" col-12 mb-5 border rounded-3 border-3 mt-2">

                <div id="map1" class="fixed-mapCluster">

                    <div class="position-absolute" id="map_tooltip" data-bs-html="true">

                    </div>

                </div>

            </div>


        </div>

    </div>
</div>

<div class="modal fade" id="sendMessage" tabindex="-1" aria-labelledby="" aria-hidden="true" data-backdrop="false"
    data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <form #message="ngForm" (ngSubmit)="sendMessage(message)" class="modal-content p-1">

            <div class="modal-header dirI">

                <h3 class="modal-title"> ارسال پیام </h3>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div dir="rtl" class=" col-12 mb-2 p-2 mt-">

                <textarea dir="rtl" [ngModel]="" name="strMessage" class="form-control mb-2" cols="20" rows="7"
                    placeholder="پیام خود را وارد کنید"></textarea>

                <input dir="rtl" type="checkbox" [ngModel]="false" name="bSendPush" class="mt-2"> ارسال پیام درون برنامه
                ای

                <input dir="rtl" type="checkbox" [ngModel]="false" name="bSaveMessage" class=" mx-2 mt-2"> ثبت پیام در
                کارتابل


            </div>

            <div class="mb-2">

                <button class="btn mx-2 px-5 btn-primary" type="submit"> ارسال </button>

            </div>

        </form>

    </div>


</div>

<div class="modal fade" id="stdEdit" tabindex="-1" aria-hidden="true" data-backdrop="false" data-bs-backdrop='static'
    data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-xl">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h3 class="modal-title"> {{bDataLoaded == false ? 'در حال دریافت اطلاعات ...' : 'ویرایش' }}</h3>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="closeEditModal()"></button>

            </div>

            <div class="modal-std">

                <div *ngIf="!bDataLoaded" class="d-flex justify-content-center align-items-center ">

                    <img src="../../../../assets/Img/school_2.gif" alt="loading">

                </div>

                <app-new-student *ngIf="std_PhoneNumber != undefined" [std_PhoneNumber]="std_PhoneNumber"
                    (closeModal)="closeEditModal()" (isDataLoaded)="bDataLoaded=true">

                </app-new-student>

            </div>

        </div>

    </div>

</div>

<div dir="rtl" class="modal fade" id="userActive" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="">فعالیت کاربر</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body ">
                <div *ngIf="userActivity.length > 0" class="table-responsive dirI rounded " style="max-height: 60vh;">
                    <table class="table table-striped rounded " id="excel-table-area-log">
                        <thead>
                            <tr class="text-center f14 ">
                                <th scope="col">#</th>
                                <th scope="col">نوع اقدام</th>
                                <th scope="col">تاریخ</th>
                                <th scope="col">زمان</th>
                                <th scope="col">IP</th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr class="text-center pointer f12 " *ngFor="let item of userActivity;let i=index ">
                                <th class="text-secondary ">{{i+1|faNum}}</th>
                                <th class="text-secondary ">{{item.strPassenger_ActionType_strComment}}</th>
                                <th class="text-secondary ">{{item.strDate|faNum}}</th>
                                <th class="text-secondary ">{{item.strTime|faNum}}</th>
                                <th class="text-secondary"><a class="text-decoration-none text-primary pointer"
                                        target="_blank"
                                        href="https://whatismyipaddress.com/ip/{{item.strUserIP.trim()}}">{{item.strUserIP.trim()
                                        |faNum}}</a></th>
                            </tr>

                        </tbody>
                    </table>
                </div>

                <div *ngIf="userActivity.length == 0" class="text-center">
                    <span>موردی یافت نشد</span>
                </div>
            </div>
            <div class="modal-footer"> </div>
        </div>
    </div>
</div>

<div dir="rtl" class="modal fade" id="userAbsence" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title" id=""> حضور و غیاب </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body ">

                <div *ngIf="list_Absence.length > 0" class="table-responsive dirI rounded " style="max-height: 60vh;">
                    <table class="table table-striped rounded " id="excel-table-area-log">
                        <thead>
                            <tr class="text-center f14 ">
                                <th scope="col">#</th>
                                <th scope="col"> نام و نام خانوادگی </th>
                                <th scope="col"> روز </th>
                                <th scope="col">تاریخ</th>
                                <th scope="col">زمان</th>
                                <th scope="col">شماره تماس</th>
                            </tr>
                        </thead>

                        <tbody>

                            <tr class="text-center pointer f12 " *ngFor="let item of list_Absence;let i=index ">

                                <th class="text-secondary ">{{i+1|faNum}}</th>

                                <th class="text-secondary ">{{item.strPassenger_FullName}}</th>

                                <th class="text-secondary ">{{item.strDate|faNum}}</th>

                                <th class="text-secondary ">{{item.strDayName|faNum}}</th>

                                <th class="text-secondary ">{{item.strTime|faNum}}</th>

                                <th class="text-secondary ">{{item.strMobile|faNum}}</th>

                        </tbody>

                    </table>

                </div>

                <div *ngIf="list_Absence.length == 0" class="text-center">
                    <span>موردی یافت نشد</span>
                </div>
            </div>
            <div class="modal-footer"> </div>
        </div>
    </div>
</div>

<div class="modal fade" id="stdFinancial" tabindex="-1" aria-hidden="true" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-xl">

        <div *ngIf="!bAddFinancial" class="modal-content p-1">

            <div class="modal-header dirI">

                <h6 class="modal-title"> گزارش مالی </h6>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body row p-2 gx-2 gy-2 ">

                <div class=" col-6 col-md-2" *ngIf="bFinancial_Edit">

                    <button class="btn w-100 btn-primary px-4"
                        (click)="bAddFinancial = true;financialModel={iDebit:'',iCredit:'',strComment:'',bCheck:false}">

                        افزودن

                    </button>

                </div>

                <div class="text-center col-6 col-md-2">

                    <button class="btn w-100 btn-success" (click)="financial_Excel()"> خروجی اکسل </button>

                </div>

                <div [ngClass]="!bFinancial_Edit ? 'col-12 col-md-10' : 'col-12 col-md-8' ">

                    <input dir="rtl" type="search" #search (input)="search_Finance(search.value)" class="form-control"
                        placeholder="جستجو کنید">

                </div>

                <div class="table-responsive dirI rounded mt-2 border boder-2 " style="max-height: 60vh;">

                    <table class="table table-striped rounded " id="financial_Excel">

                        <thead>

                            <tr class="text-center ">

                                <th scope="col">#</th>

                                <th scope="col" *ngIf="bFinancial_Edit || bFinancial_Delete"> عملیات </th>

                                <th scope="col"> تاریخ </th>

                                <th scope="col"> {{ !bPersonnel ? 'بستانکاری دانش آموز' : 'بستانکاری پرسنل' }} </th>

                                <th scope="col"> {{ bPersonnel ? 'بدهکاری پرسنل' : 'بدهکاری دانش آموز' }} </th>

                                <th scope="col"> چک </th>

                                <th scope="col"> شرح </th>

                            </tr>

                        </thead>

                        <tbody>

                            <tr class="text-center " *ngFor="let item of list_Finance;let i=index ">

                                <th class="text-secondary ">{{i+1|faNum}}</th>

                                <td *ngIf="bFinancial_Edit || bFinancial_Delete">

                                    <i *ngIf="bFinancial_Edit"
                                        class="fa fa-pencil-square-o fa-lg text-primary mx-2 pointer"
                                        (click)="editFinancial(item)" aria-hidden="true"></i>

                                    <i *ngIf="bFinancial_Delete" class="fa fa-trash fa-lg text-danger pointer"
                                        (click)="removeFinancial(item)" aria-hidden="true"></i>

                                </td>

                                <td>{{item.strDate | faNum}}</td>

                                <td>{{item.iCredit.toLocaleString() | faNum}}</td>

                                <td>{{item.iDebit.toLocaleString() | faNum}}</td>

                                <td>{{item.strCheck | faNum}}</td>

                                <td>{{item.strComment | faNum}}</td>

                        </tbody>

                    </table>

                </div>

                <div class="row p-2 gx-2 gy-2 justify-content-center bg-warning rounded">

                    <div class=" col-12 col-md-5 text-center">

                        <b> مبلغ کل بدهکاری : {{ iTotalOwed.toLocaleString() + ' ریال ' | faNum}} </b>

                    </div>

                    <div class="col-12 col-md-5 text-center">

                        <b> مبلغ کل بستانکاری : {{iTotalCreditor.toLocaleString() + ' ریال ' | faNum}} </b>

                    </div>

                </div>

            </div>

        </div>

        <div *ngIf="bAddFinancial" class="modal-content p-1">

            <div class="modal-header dirI">

                <h6 class="modal-title"> {{editMode ? 'ویرایش گزارش مالی' : 'افزودن گزارش مالی' }} </h6>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div dir="rtl" class="modal-body row p-2 gx-2 gy-2 ">

                <div class="col-12 col-md-3">

                    <label>تاریخ</label>

                    <form [formGroup]="date">

                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input id="startDate" type="text" formControlName="strDate"
                                class="form-control  text-end" />

                        </ng-persian-datepicker>

                    </form>

                </div>

                <div class="col-12 col-md-3">

                    <label> {{bPersonnel ? 'بدهکاری پرسنل (ریال)' : 'بدهکاری دانش آموز (ریال)' }} </label>

                    <input
                        oninput="this.value = this.value.replace(/[^0-9]/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        type="text" name="iDebit" [(ngModel)]="financialModel.iDebit" class="form-control">

                </div>

                <div class="col-12 col-md-3">

                    <label> {{ bPersonnel ? 'بستانکاری پرسنل (ریال)' : 'بستانکاری دانش آموز (ریال)' }} </label>

                    <input
                        oninput="this.value = this.value.replace(/[^0-9]/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        type="text" [(ngModel)]="financialModel.iCredit" class="form-control">

                </div>

                <div class="form-check form-switch m-0 d-flex align-items-end col-12 col-md-3 p-2">

                    <input class="form-check-input m-0" type="checkbox" id="bCheck" [(ngModel)]="financialModel.bCheck">

                    <label class="form-check-label pointer text-muted me-2" for="bCheck"> پرداخت به وسیله چک </label>

                </div>

                <div class="col-12 ">

                    <label> توضیحات </label>

                    <textarea class="form-control" [(ngModel)]="financialModel.strComment"></textarea>

                </div>

                <div class="row p-2 gx-2 gy-2 d-flex justify-content-end">

                    <div class=" col-12 col-md-2 me-0 me-md-2">

                        <button [ngClass]="editMode ? 'btn-primary' : 'btn-success' " class="btn px-4 w-100"
                            (click)="saveFinancial_Report()"> {{editMode ? ' ویرایش ' : 'ذخیره' }} </button>

                    </div>

                    <div class=" col-12 col-md-2">

                        <button class="btn btn-danger w-100 px-4" (click)="bAddFinancial = false;editMode=false"> بازگشت
                        </button>

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>

<!-- افزودن پرسنل -->

<div class="modal fade" id="NewPersonnel" tabindex="-1" aria-hidden="true" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title"> {{ bEdit_Std ? 'ویرایش پرسنل' : 'افزودن پرسنل' }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body" style="direction: rtl;">

                <!-- بررسی شماره موبایل -->

                <ng-container *ngIf="!bEdit_Std">

                    <div [formGroup]="mdl_Search" class="container-fluid row gx-2 gy-2 p-2">

                        <!-- شماره موبایل -->

                        <div class="position-relative col-12 col-md-10 p-2">

                            <label class="mb-2 text-muted"> شماره موبایل پرسنل </label>

                            <input class="form-control p-2 text-center" maxlength="11"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')" formControlName="strMobile">

                        </div>

                        <!-- بررسی -->

                        <div class="position-relative col-12 col-md-auto p-2">

                            <button class="btn btn-primary w-100" (click)="personnelSearch()">

                                بررسی

                            </button>

                        </div>

                        <hr>

                    </div>

                </ng-container>

                <!-- فرم دریافت اطلاعات -->

                <div [formGroup]="mdl_Personnel" class="container-fluid row gx-2 gy-2 p-2">

                    <!-- نام -->

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> نام </label>

                        <input class="form-control p-2 text-center" formControlName="strName">

                    </div>

                    <!-- نام خانوادگی -->

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> نام خانوادگی </label>

                        <input class="form-control p-2 text-center" formControlName="strFamily">

                    </div>

                    <!-- شماره موبایل -->

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> شماره موبایل </label>

                        <input class="form-control p-2 text-center" maxlength="11"
                            oninput="this.value=this.value.replace(/[^0-9]/g,'')" formControlName="strMobile">

                    </div>

                    <!-- جایگاه سازمانی -->

                    <div class="col-12 col-md-4 position-relative p-2">

                        <label class="mb-2 text-muted"> جایگاه سازمانی </label>

                        <custom-filter *ngIf="showFilter"
                            [strValue]="returnStrValue('strChart',mdl_Personnel.get('strChart')?.value,lst_UserManager,'strComment')"
                            [strComment]="'strComment'" [stylesArray]="['padding-top: 10px','text-align: center']"
                            [str_Placeholder]="' جایگاه سازمانی را جستجو کنید'" [lst_Main]="lst_UserManager"
                            [lst_SearchKey]="['strComment']" [isDisabled]="mdl_Personnel.disabled ? true : false"
                            (hideOptions)="setValue_Filter($event,'strChart')">

                        </custom-filter>

                    </div>

                    <!-- حوزه خدمت -->

                    <div class="col-12 col-md-4 position-relative p-2">

                        <label class="mb-2 text-muted"> حوزه خدمت </label>

                        <custom-filter *ngIf="showFilter"
                            [strValue]="returnStrValue('iMobileDomain',mdl_Personnel.get('iMobileDomain')?.value,list_Schools,'strComment')"
                            [strComment]="'strComment'" [stylesArray]="['padding-top: 10px','text-align: center']"
                            [str_Placeholder]="'حوزه خدمت  را جستجو کنید'" [lst_Main]="list_Schools"
                            [lst_SearchKey]="['strComment']" [isDisabled]="mdl_Personnel.disabled ? true : false"
                            (hideOptions)="setValue_Filter($event,'iMobileDomain')">

                        </custom-filter>

                    </div>

                    <!-- جنسیت -->

                    <div class="col-12 col-md-4 position-relative p-2">

                        <label class="mb-2 text-muted"> جنسیت </label>

                        <select class="form-select p-2" formControlName="tiSex">

                            <option class="text-center" [value]="-1"> انتخاب کنید </option>

                            <option class="text-center" value="1">آقا</option>

                            <option class="text-center" value="2">خانم</option>

                        </select>

                    </div>

                    <!-- کد ملی / پرسنلی -->

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> کد ملی / پرسنلی </label>

                        <input class="form-control p-2 text-center" maxlength="10"
                            oninput="this.value = this.value.replace(/[^0-9]/g,'')" formControlName="strNationalCode">

                    </div>

                    <!-- شناسه RFID -->

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> شناسه RFID </label>

                        <input class="form-control p-2 text-center" formControlName="strRFIDCodes">

                    </div>

                    <!-- ساعت شروع فعالیت-->

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted" style="z-index: 10;"> ساعت شروع فعالیت </label>

                        <div class="input-group clockpicker">

                            <input autocomplete="off" class="form-control p-2 text-center" id="strSTime"
                                formControlName="strSTime">

                            <span class="input-group-addon">

                                <span class="glyphicon glyphicon-time"></span>

                            </span>

                        </div>

                    </div>

                    <!-- ساعت پایان فعالیت-->

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted" style="z-index: 10;"> ساعت پایان فعالیت</label>

                        <div class="input-group clockpicker">

                            <input autocomplete="off" class="form-control p-2 text-center" id="strETime"
                                formControlName="strETime">

                            <span class="input-group-addon">

                                <span class="glyphicon glyphicon-time"></span>

                            </span>

                        </div>

                    </div>

                    <!-- فعال -->

                    <div *ngIf="bEdit_Std" class="form-check form-switch m-0 d-flex align-items-center col-auto p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bActive" formControlName="bActive">

                        <label class="form-check-label pointer text-muted me-2" for="bActive"> فعال </label>

                    </div>

                    <!-- آدرس -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> آدرس </label>

                        <custom-map *ngIf="showCustom_Map" [strValue]="mdl_Personnel.get('strAddress')?.value"
                            [longLat]="[mdl_Personnel.get('fOriginLon')?.value,mdl_Personnel.get('fOrigiLat')?.value]"
                            [stylesArray]="['padding-top: 10px']" [isDisabled]="mdl_Personnel.disabled ? true : false"
                            [isTextArea]="false" [isLocationBtn]="mdl_Personnel.disabled ? false : true"
                            [str_Placeholder]="'آدرس خود را جستجو کنید ...'" (mdl_Submit)="submitData($event)">

                        </custom-map>

                    </div>

                    <!-- طول جغرافیایی -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> طول جغرافیایی </label>

                        <input class="form-control p-2 text-center" formControlName="fOriginLon">

                    </div>

                    <!-- عرض جغرافیایی -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> عرض جغرافیایی </label>

                        <input class="form-control p-2 text-center" formControlName="fOrigiLat">

                    </div>

                </div>

            </div>

            <div class="modal-footer">

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    بستن

                </button>

                <button class="btn" [ngClass]="bEdit_Std ? 'btn-primary' : 'btn-success' "
                    [disabled]="!bEdit_Std && mdl_Personnel.disabled" (click)="submit_NewPersonnel()">

                    {{ bEdit_Std ? 'ویرایش' : 'افزودن' }}

                </button>

            </div>

        </div>

    </div>

</div>

<!-- ثبت موقعیت -->

<div class="modal fade" id="maplat" tabindex="-1" aria-labelledby="" aria-hidden="true" data-backdrop="false"
    data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-xl">

        <div class="modal-content p-1" style="direction: rtl;">

            <div class="modal-header">

                <h5 class="modal-title">ثبت موقعیت</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div id="map" class="position-sticky w-100 " style="height: 500px;">

                <div [formGroup]="mdl_Personnel"
                    class="d-flex justify-content-around position-absolute dirI bg-th-yellow w-100 p-1"
                    style="z-index: 1000; margin-bottom: 10px;">

                    <div class="mx-1">

                        <!-- <label for="lat"> عرض جغرافیایی : </label> -->

                        <input class readonly id="lat" type="text" formControlName="fOrigiLat" class="mx-2" #lat>

                    </div>


                    <div class="mx-1 d-flex align-items-center">

                        <!-- <label for="lon"> طول جغرافیایی : </label> -->

                        <input readonly id="lon" type="text" formControlName="fOriginLon" class="mx-2">

                    </div>

                </div>

                <div class="position-absolute" id="map_tooltip" data-bs-html="true"></div>

            </div>

            <button *ngIf="lat.value != ''" (click)="confirmLatol()" style="width: fit-content;" data-bs-dismiss="modal"
                class="btn btn-success my-2">

                &nbsp; تایید &nbsp;

                <i class="fa fa-check"></i>

            </button>

        </div>

    </div>

</div>

<!-- مدال لیست گزارشات -->

<div class="modal fade" id="viewModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> لیست گزارشات </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <section class="row gx-0 gy-0">

                    <div class="d-flex justify-content-end" *ngIf="accessibility('bSchoolService_DailyReports_Save')">

                        <button class="btn btn-primary" (click)="addReport(clickedItem)">

                            افزودن

                        </button>

                        <button class="col-auto w-md-auto btn btn-success mx-2" (click)="exportExcel('Export_Excelx')">

                            <span> خروجی اکسل </span>

                            <i class="fa fa-file-excel-o mx-2" aria-hidden="true"></i>

                        </button>

                    </div>


                    <div class="mt-3">

                        <div class="section border border-2 mt-2"
                            style="max-height:calc(100vh - 400px);overflow: auto;">

                            <table class="col-12 table table-striped rounded-3" id="Export_Excelx">

                                <thead>

                                    <tr class="">

                                        <th class="text-center col-1"> # </th>

                                        <th class="text-center col-1"> عملیات </th>

                                        <th class="text-center"> تاریخ </th>

                                        <th class="text-center"> دانش آموز </th>

                                        <th class="text-center"> ثبت کننده </th>

                                        <th class="text-center"> مرکز آموزشی </th>

                                        <th class="text-center"> توضیحات </th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr class="col-12 text-center" *ngFor="let item of lst_Result;let i = index">

                                        <th> {{ i + 1 | faNum }} </th>

                                        <td class="">

                                            <ng-container>

                                                <i class="fa fa-eye fa-lg mx-2 pointer" title="مشاهده"
                                                    (click)="viewItemInfo(item)"></i>

                                            </ng-container>

                                            <ng-container *ngIf="accessibility('bSchoolService_DailyReports_Delete')">

                                                <i class="fa fa-trash fa-lg pointer" title="حذف"
                                                    (click)="removeItem(item,i)"></i>

                                            </ng-container>

                                        </td>

                                        <td> {{ item.strDate | faNum }} </td>

                                        <td [innerHTML]="highlightText(item.strStudentFullName,'')"> </td>

                                        <td [innerHTML]="highlightText(item.strFullName,'')"> </td>

                                        <td [innerHTML]="highlightText(item.strMobileDomain_strComment,'')  | faNum">
                                        </td>

                                        <td style="max-width: 300px;text-wrap: auto;text-align: right;">

                                            <span class="p-1">

                                                {{ item.strComment | faNum }}

                                            </span>

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>

                    </div>

                </section>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<!-- مدال ثبت گزارش روزانه -->

<div class="modal fade" id="addReportModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> ثبت گزارش روزانه </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body" style="max-height:calc(100vh - 400px);overflow: auto;">

                <section [formGroup]="mdl_ReportDaily" class="row gx-0 gy-3">

                    <div (click)="fileInput.click()" class="image-uploader-container col-12 p-2">

                        <img src="{{ mdl_ReportDaily.get('strImage').value != '' ?
                            
                                'data:image/jpeg;base64,' + mdl_ReportDaily.get('strImage').value :
                                
                                '../../../assets/Img/gallery.jpg' }}" alt="">

                        <p> تصویر خود را آپلود کنید </p>

                        <input hidden type="file" #fileInput (change)="onFileInput($event.target.files[0]);" />

                    </div>

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted" style="top: -8px;"> توضیحات </label>

                        <textarea style="height: 200px;resize: none;" maxlength="500"
                            placeholder="توضیحات خود را وارد کنید ..." class="form-control"
                            formControlName="strComment">

                        </textarea>

                    </div>

                </section>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-success" (click)="submitReport_Daily()">

                    &nbsp; ثبت &nbsp;

                </button>

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<!-- مدال مشاهده -->

<div class="modal fade" id="viewModalInfo" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> مشاهده </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <section class="row gx-0 gy-0">

                    <!-- اطلاعات دانش آموز -->

                    <div class="col-12 col-md-5">

                        <div class="row gx-0 gy-md-0 gy-3 p-0 m-0">

                            <!-- تصویر -->

                            <div class="col-12 d-flex align-items-center justify-content-center p-2">

                                <img class="student-avatar" id="fullScreen_" (click)="fullScreen_Image()" src="{{obj_Std.strImage ? 'data:image/png;base64,' + obj_Std.strImage :
                                    
                                    '../../../assets/Img/preview__thumbnail.png' }}" loading="lazy">

                            </div>

                            <!-- نام دانش آموز -->

                            <div class="col-12 mb-3">

                                <p class="mb-0">

                                    <span class="fw-bold text-muted"> نام دانش آموز : </span>

                                    <span class="text-primary"> {{ obj_Std.strStudentFullName }} </span>

                                </p>

                            </div>

                            <!-- پایه -->

                            <div class="col-12 col-md-6 mb-3">

                                <p class="mb-0">

                                    <span class="fw-bold text-muted"> پایه : </span>

                                    <span class="text-primary"> {{ obj_Std.strGrade }} </span>

                                </p>

                            </div>

                            <!-- کلاس -->

                            <div class="col-12 col-md-6 mb-3">

                                <p class="mb-0">

                                    <span class="fw-bold text-muted"> کلاس : </span>

                                    <span class="text-primary"> {{ obj_Std.strTitel }} </span>

                                </p>

                            </div>

                            <!-- کد ملی -->

                            <div class="col-12">

                                <p class="mb-0">

                                    <span class="fw-bold text-muted"> کد ملی : </span>

                                    <span class="text-primary"> {{ obj_Std.strNationalCode | faNum }} </span>

                                </p>

                            </div>

                        </div>

                    </div>

                    <!-- اطلاعات -->

                    <div class="col-12 col-md-6 border-end pe-md-3">

                        <div class="row gx-0 gy-3 p-0 m-0">

                            <!-- تاریخ ثبت -->

                            <div class="col-12 col-md-6">

                                <p class="mb-0">

                                    <span class="fw-bold text-muted"> تاریخ ثبت : </span>

                                    <span class="text-primary"> {{ obj_Std.strDate | faNum }} </span>

                                </p>

                            </div>

                            <!-- ساعت ثبت -->

                            <div class="col-12 col-md-6">

                                <p class="mb-0">

                                    <span class="fw-bold text-muted"> ساعت ثبت : </span>

                                    <span class="text-primary"> {{ obj_Std.strTime | faNum }} </span>

                                </p>

                            </div>

                            <!-- ثبت کننده -->

                            <div class="col-12 col-md-6">

                                <p class="mb-0">

                                    <span class="fw-bold text-muted"> ثبت کننده : </span>

                                    <span class="text-primary"> {{ obj_Std.strFullName | faNum }} </span>

                                </p>

                            </div>

                            <!-- محتوای گزارش -->

                            <div class="col-12">

                                <p class="mb-0">

                                    <span class="fw-bold text-muted"> محتوای گزارش : </span>

                                    <span class="text-primary"> {{ obj_Std.strComment | faNum }} </span>

                                </p>

                            </div>

                        </div>

                    </div>

                </section>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<!-- مدال شارژ اعتبار -->

<div class="modal fade" id="creditModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> 

                    {{ mdl_Charge.get('strPassenger_FullName')?.value }} 
                    
                    (<small style="font-size: 16px;"> اعتبار فعلی : 
                        
                        <span style="color: navy;"> {{ mdl_Charge.get('current_iAmount')?.value | number | faNum }} ریال </span>
                    
                    </small>)
                    
                </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <section class="row gx-0 gy-0">

                    <div class="p-2">

                        <div class="row gx-0 gy-0">

                           <div class="col-10">

                                <input type="text" class="w-100 form-control" placeholder="جستجو کنید ...">

                           </div>

                           <div class="col-2 px-2">

                               <button class="btn btn-success" (click)="open_AddCredit()"> 

                                    افزودن

                               </button>

                           </div>

                        </div>

                        <div class="section border border-2 mt-2" style="max-height: 50vh;">

                            <table class="table table-striped bg-white mt-1 dirI" id="excel-list">

                                <thead>

                                    <tr class="text-center">

                                        <th scope="col"> # </th>

                                        <th scope="col"> تاریخ </th>

                                        <th scope="col"> مبلغ(ریال) </th>

                                        <th scope="col"> توضیحات </th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr class="f14 text-center" *ngFor="let item of lst_Credit;let i=index">

                                        <th class="text-dark"> {{ i + 1 | faNum }}</th>

                                        <td class="text-dark"> {{ item.strFullDate | faNum }}</td>

                                        <td class="text-dark"> {{ item.iAmount | number | faNum }}</td>

                                        <td class="text-dark"> {{ item.strTrackingCode | faNum }}</td>

                                    </tr>

                                    <tr class="f14 text-center">

                                        <th class="text-dark"> سرجمع : </th>

                                        <td class="text-dark"> </td>

                                        <td class="text-dark fw-bold"> {{ iAmount | number | faNum }}</td>

                                        <td class="text-dark"> </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>

                    </div>

                </section>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<!-- افزودن اعتبار -->

<div class="modal fade" id="addCreditModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> افزودن اعتبار </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_Charge" class="row gx-0 gy-0">

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> مبلغ(ریال) </label>

                        <input oninput="this.value = this.value.replace(/[^0-9]/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')" class="form-control p-2 text-end" formControlName="iAmount">

                    </div>

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> توضیحات </label>

                        <textarea style="height: 100px;resize: none;" class="form-control" formControlName="strTrackingCode"></textarea>

                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-success" (click)="submitCredit()">

                    &nbsp; &nbsp; ثبت &nbsp; &nbsp;

                </button>

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<ng-container *ngIf="isLoading">

    <div class="school_loading">

        <img *ngIf="!bPersonnel" src="../../../../assets/Img/school_2.gif" alt="loading">

        <p *ngIf="bPersonnel"> ... لطفا منتظر بمانید </p>

    </div>

</ng-container>